import { SortBarItemProps, useTranslations } from "@harea/component"

export const useDayOffListSort = (): Array<SortBarItemProps> => {
    const [NAME, DATE, ADDED_AT] = useTranslations(i18n)
    return [
        { label: NAME, value: 'employee.fullName' },
        { label: DATE, className: "ml-auto", value: 'createdAt' },
    ]
}

const i18n = ['std_name', 'std_date', 'std_added_at']
